import React from 'react';
import IEmptyState from "EmptyState";
import classNames from 'classnames';

export interface ISelectorItemProps {
    value?: number;
    iconUrl?: string;
    selected?: boolean;
    subtitle?: string;
    onClick?: ((sender: SelectorItem) => void);
}

export default class SelectorItem extends React.Component<ISelectorItemProps, IEmptyState> {
    constructor(props: ISelectorItemProps) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    public static defaultProps: Partial<ISelectorItemProps> = {
        selected: false
    };

    private handleClick() {
        this.props.onClick?.(this);
    }

    public render() {
        return (
            <div className={classNames("selector-item", {"active": this.props.selected})} onClick={this.handleClick}>
                {this.props.iconUrl && 
                    <div className="icon" style={{backgroundImage: 'url(' + this.props.iconUrl + ')'}}></div>
                }
                <div className="content">
                    {this.props.children}
                    {this.props.subtitle && 
                        <div className="subtitle">
                            {this.props.subtitle}
                        </div>
                    }
                </div>
            </div>
        );
    }
}